// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eJcSfhpV{position:relative}.I-KizBZr{display:block}._0q2nAry1{cursor:not-allowed}label.I-KizBZr{cursor:pointer}label.I-KizBZr:has(input[type=checkbox]){width:-moz-fit-content;width:fit-content}.eleTVKf4{--s0:0!important;font-size:.75rem;gap:.5ch;line-height:1.33}.eleTVKf4,.NqsA0f2N{align-items:flex-start;display:flex}.NqsA0f2N{gap:.25rem;padding-bottom:.25rem}.eY1cV9P7:after{color:var(--color-error);content:\" *\";transform:scale(150%)}.eleTVKf4 a{color:var(--color-primary)}@media(hover:hover){.eleTVKf4 a:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.eleTVKf4 a:active{-webkit-text-decoration:underline;text-decoration:underline}}._0\\+tAUuXu{color:var(--color-error);font-size:.75rem;line-height:1.33;padding-top:.25rem}._0\\+tAUuXu a{-webkit-text-decoration:underline;text-decoration:underline}._0\\+tAUuXu,.eleTVKf4{max-width:100%;word-wrap:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "eJcSfhpV",
	"inner": "I-KizBZr",
	"innerDisabled": "_0q2nAry1",
	"label": "eleTVKf4",
	"labelWrapper": "NqsA0f2N",
	"labelRequired": "eY1cV9P7",
	"error": "_0+tAUuXu"
};
module.exports = ___CSS_LOADER_EXPORT___;
